module.exports = __webpack_public_path__ + "img/com.codeway.circles.e4b45f5b.png";